<template>
    <div class="relative" :class="{ 'py-8' : step == steps.COMPLETED }">

        <steps class="mb-5" :current-step="step" />

        <preloader
            v-if="isActionInProgress"
        />

        <step1
            v-if="step == steps.INDEX"
            :cartData="cartData"
            :stockError="stockError"
            :isActionInProgress="isActionInProgress"
            @go-to-delivery="goToDelivery"
            @toggle-preloader="togglePreloader"
            @load-cart-data="loadCartData"
            @show-message="fireSwalMessage"
        />
        <step2
            v-if="step == steps.DELIVERY"
            :payment="payment"
            :delivery-type="deliveryType"
            :address="address"
            :invoice="invoice"
            :client="client"
            :registration="registration"
            :has-only-tickets-ordered="hasOnlyTicketsOrdered"
            :has-only-records-ordered="hasOnlyRecordsOrdered"
            :has-only-gift-cards-ordered="hasOnlyGiftCardsOrdered"
            :has-any-ticket-ordered="hasAnyTicketOrdered"
            :has-any-record-ordered="hasAnyRecordOrdered"
            :has-any-gift-card-ordered="hasAnyGiftCardOrdered"
            :pickup-point="pickupPoint"
            :was-sending-tickets-selected="isDeliveryRequired"
            :consents="consents"
            :consents-content="consentsContent"
            :client-comments="client_comments"
            :has-free-shipping="hasFreeShipping"
            :can-select-tickets-delivery-method="canSelectTicketsDeliveryMethod"
            @select-pickup-point="selectPickupPoint"
            @go-to-summary="goToSummary"
            @toggle-preloader="togglePreloader"
            @back-to-prev-step="backToPreviousStep"
        />
        <step3
            v-if="step == steps.SUMMARY"
            :cartData="cartData"
            :payment="payment"
            :delivery-type="deliveryType"
            :pickup-point="pickupPoint"
            :address="address"
            :invoice="invoice"
            :client="client"
            :registration="registration"
            :errors="errors"
            :is-delivery-required="isDeliveryRequired"
            :client-comments="client_comments"
            :has-free-shipping="hasFreeShipping"
            :has-any-ticket-ordered="hasAnyTicketOrdered"
            :has-any-gift-card-ordered="hasAnyGiftCardOrdered"
            @save-order="saveOrder"
            @back-to-prev-step="backToPreviousStep"
            @show-message="fireSwalMessage"
            @change-product-quantity="changeProductQuantity"
        />

        <template v-if="step == steps.COMPLETED">
            <p class="text-3xl font-light text-center">
                {{ __('Twoje zamówienie zostało poprawnie zapisane.') }}
            </p>
            <p class="text-3xl font-light text-center">
                {{ __('Za chwilę zostaniesz przekierowany do systemu płatności.') }}
            </p>

            <count-down
                class="py-8"
                @completed="goToThePaymentSystem"
            />
        </template>

    </div>
</template>

<script>
const STEPS = {
    INDEX: 1,
    DELIVERY: 2,
    SUMMARY: 3,
    COMPLETED: 4,
};

import axios from "axios";
import Steps from './Steps';
import Step1 from './Steps/Step1';
import Step2 from './Steps/Step2';
import Step3 from './Steps/Step3';
import CountDown from '../CountDown';

export default {
    components: {
        Preloader: () => import("@/common/components/Preloader"),
        Steps,
        Step1,
        Step2,
        Step3,
        CountDown
    },
    props: {
        consentsContent: Object
    },
    data() {
        return {
            isActionInProgress: false,
            steps: STEPS,
            step: STEPS.INDEX,
            cartData: {},
            payment: _.get(window.Laravel, 'paymentTypes.0.key', ""),
            deliveryType: null,
            deliveryDiscountedPrice: null,
            pickupPoint: null,
            client: {},
            address: {},
            invoice: {
                show_form: false,
                name: '',
                nip: '',
                email: '',
                street: '',
                house_number: ''
            },
            registration: {
                register: false,
                password: '',
                password_confirmation: ''
            },
            consents: {},
            isDeliveryRequired: false,
            paymentUrl: "",
            errors: {},
            stockError: {},
            client_comments: '',
            hasOnlyTicketsOrdered: false,
            hasOnlyRecordsOrdered: false,
            hasOnlyGiftCardsOrdered: false,
            hasAnyTicketOrdered: false,
            hasAnyRecordOrdered: false,
            hasAnyGiftCardOrdered: false,
            isPolishLangVersion: window.Laravel.locale == 'pl',
            canSelectTicketsDeliveryMethod: false,
        };
    },
    computed: {
        isCartDataLoaded() {
            return ! this.isCartEmpty;
        },
        totalPrice() {
            return parseFloat(this.cartData.total_price);
        },
        hasFreeShipping() {
            return this.cartData.has_free_shipping;
        }
    },
    mounted() {
        this.loadCartData();
        this.checkoutProgressEvent(this.step);
    },
    methods: {
        togglePreloader() {
            this.isActionInProgress = ! this.isActionInProgress;
        },
        goToDelivery(){
            this.isActionInProgress = false;
            this.step = STEPS.DELIVERY;
            this.checkoutProgressEvent(this.step);
        },
        goToSummary(data){
            Object.assign(this.$data, data);

            this.applyPromotionalCode();
        },
        changeStepToSummary() {
            this.step = STEPS.SUMMARY;
            this.checkoutProgressEvent(this.step);
            this.isActionInProgress = false;
        },
        applyPromotionalCode() {
            this.isActionInProgress = true;

            axios
                .post(route("json.cart.apply_promotional_code"), {
                    promotional_code: this.cartData.promotional_code,
                    email: this.client.email,
                    delivery_type_id: _.get(this.deliveryType , 'id', null),
                })
                .then((response) => {
                    let message = _.get(response, "data.message", "");
                    let deliveryDiscountedPrice = _.get(response, "data.delivery_discounted_price", null);

                    this.cartData = _.get(response, "data.data", {});

                    if (! _.isNull(deliveryDiscountedPrice)) {
                        this.deliveryType.price = _.get(response, "data.delivery_discounted_price", this.deliveryType.price);
                    }

                    if(message.length > 0) {
                        this.fireSwalMessage(message);
                    }
                })
                .catch((error) => {
                    this.loadCartData();
                    this.fireSwalMessage(_.get(error.response, "data.message", ""), "error");
                })
                .then(() => {
                    this.isActionInProgress = false;
                    this.changeStepToSummary();
                });
        },
        loadCartData() {
            this.isActionInProgress = true;

            axios
                .get(route('json.cart.get'))
                .then(response => {
                    this.cartData = _.get(response, "data.data", []);
                    this.client = _.get(response, "data.client", []);
                    this.address = _.get(response, "data.address", []);
                    this.hasOnlyTicketsOrdered = _.get(this.cartData, "has_only_tickets_ordered", false);
                    this.hasOnlyRecordsOrdered = _.get(this.cartData, "has_only_records_ordered", false);
                    this.hasOnlyGiftCardsOrdered = _.get(this.cartData, "has_only_gift_cards_ordered", false);
                    this.hasAnyTicketOrdered = _.get(this.cartData, "has_any_ticket_ordered", false);
                    this.hasAnyRecordOrdered = _.get(this.cartData, "has_any_record_ordered", false);
                    this.hasAnyGiftCardOrdered = _.get(this.cartData, "has_any_gift_card_ordered", false);
                    this.canSelectTicketsDeliveryMethod = _.get(this.cartData, "can_select_tickets_delivery_method", false);
                })
                .catch(error => {
                    console.log(error);
                })
                .then(() => {
                    this.isActionInProgress = false;
                    this.beginCheckoutEvent();
                    this.sendViewCartEvent();
                });
        },
        fireSwalMessage(message, icon = 'success') {
            if(icon == 'success') {
                swal.fire({
                    icon: "success",
                    html: message,
                    showConfirmButton: false,
                    timer: 2500
                });
            } else {
                swal.fire({
                    position: "center",
                    icon: icon,
                    html: message
                });
            }
        },
        backToPreviousStep() {
            if(this.step == STEPS.INDEX) {
                return;
            }

            this.step = this.step - 1;
            this.checkoutProgressEvent(this.step);
        },
        changeProductQuantity(message){
            this.step = STEPS.INDEX
            this.stockError = message;
            swal.fire({
                icon: "warning",
                text: this.isPolishLangVersion
                    ? 'Niektóre produkty nie są już dostępne w takiej ilości jaką chcesz zamówić.'
                    : 'Some products are no longer available in the quantity you want to order.',
                showConfirmButton: false,
                timer: 2500
            });
        },
        saveOrder() {
            this.isActionInProgress = true;

            var cartData = {
                items: this.cartData.items,
                payment: this.payment,
                client: this.client,
                invoice: this.invoice,
                registration: this.registration,
                pickup_point_code: _.get(this.pickupPoint, 'name'),
                pickup_point_details: _.get(this.pickupPoint, 'address_details'),
                consents: this.consents,
                address: this.address,
                client_comments: this.client_comments,
                promotional_code: _.get(this.cartData, "promotional_code", null),
            };

            if(this.isDeliveryRequired) {
                cartData = _.merge(cartData, {
                    delivery_type_id: _.get(this.deliveryType , 'id', null),
                    address: this.address
                });
            }

            axios
                .post(route("json.cart.save_order"), cartData)
                .then((response) => {
                    this.isActionInProgress = false;
                    this.step = STEPS.COMPLETED;
                    this.checkoutProgressEvent(this.step);
                    this.purchaseEvent(_.get(response, "data.order_id"));
                    this.$eventBus.$emit("refresh-header-cart");
                    this.paymentUrl = _.get(response, "data.url", "");
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.errors = _.get(error.response, "data.errors", {});
                    }

                    this.changeProductQuantity(error.response.data);
                    this.isActionInProgress = false;
                });
        },
        goToThePaymentSystem() {
            if(this.paymentUrl && this.paymentUrl.length > 0) {
                window.location = this.paymentUrl;
            }
        },
        selectPickupPoint(point) {
            this.pickupPoint = point;
        },
        checkoutProgressEvent(step) {
            try {
                gtag('event', 'checkout_progress', {
                    "checkout_step": step,
                });
            } catch (error) {
                console.log(error);
            };
        },
        purchaseEvent(id) {
            try {
                gtag('event', 'purchase', {
                    "transaction_id": id,
                    "value": this.cartData.total_price.toFixed(2),
                    "currency": "PLN",
                    "shipping": _.isNull(this.deliveryType) ? 0 : this.deliveryType.price,
                    "items": this.parseCartDataForGTag()
                });
            } catch (error) {
                console.log(error);
            };
        },
        beginCheckoutEvent() {
            if (_.isEmpty(this.cartData)) {
                return;
            }

            try {
                gtag('event', 'begin_checkout', {
                    "items": this.parseCartDataForGTag()
                });
            } catch (error) {
                console.log(error);
            };

            try {
                waitForFbq(function () {
                    fbq("track", "InitiateCheckout", {
                        content_ids: Object.keys(this.cartData.items),
                        value: this.cartData.total_price.toFixed(2),
                        currency: "PLN",
                    });
                });
            } catch (err) {
                console.log(err);
            }
        },
        parseCartDataForGTag() {
            return Object.entries(this.cartData.items).map(function(entry) {
                const [key, value] = entry;
                return {
                    "id": value['id'],
                    "name": value['name'],
                    "quantity": value['quantity'],
                    "price": value['price'],
                    "category": value['product_category']
                };
            });
        },
        sendViewCartEvent() {
            try {
                gtag('event', 'view_cart', this.getViewCartEventData());
            } catch (error) {
                console.log(error);
            };
        },
        getViewCartEventData() {
            if (_.isEmpty(this.cartData)) {
                return {
                    currency: "PLN",
                    value: 0,
                    items: [],
                };
            }

            return {
                currency: "PLN",
                value: this.cartData.total_price,
                items: _.map(this.cartData.items, function(item) {
                    return {
                        id: item.id,
                        name: item.name,
                        quantity: item.quantity,
                        price: item.price,
                        item_category: item.product_category,
                    };
                }),
            };
        },
    }
};
</script>
